import { render } from "./returnschart.vue?vue&type=template&id=42baefbb&scoped=true&lang=html"
import script from "./returnschart.vue?vue&type=script&lang=js"
export * from "./returnschart.vue?vue&type=script&lang=js"

import "./returnschart.vue?vue&type=style&index=0&id=42baefbb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42baefbb"]])

export default __exports__